<template>
  <div class="container">
    
    <div class="progress-container">
      <div class="progress" id="progress"></div>
      <div class="circle active" @click="firstStepTrigger">
        <router-link :to="{name: 'create-tmz-step-first'}" v-if="step === 0">1</router-link>
        <router-link :to="{name: 'view-tmz-step-first', params: {id: tmzId}}" v-if="step >= 1" ref="step1">1</router-link>
      </div>
      <div class="circle" @click="secondStepTrigger">
        <router-link :to="{name: 'create-tmz-step-second', params: {tmzId: tmzId}}" v-if="step === 1">2</router-link>
        <router-link :to="{name: 'view-tmz-step-second', params: {id: tmzId}}" v-if="step >= 2" ref="step2">2</router-link>
      </div>
      <div class="circle" @click="thirdStepTrigger">
        <router-link :to="{name: 'create-tmz-step-third', params: {tmzId: tmzId}}" v-if="step === 2">3</router-link>
        <router-link :to="{name: 'view-tmz-step-third', params: {id: tmzId}}" v-if="step >= 3" ref="step3" >3</router-link>
      </div>
    </div>

    <!-- <button class="step-btn" id="prev" @click="prevStep()" >Назад</button>
    <button class="step-btn" id="next" @click="nextStep()">Вперед</button> -->


  </div>
</template>

<script>
export default {
  name: "StepHeader",
  data() {
    return {
      step: 0,
      currentStep: '',
      circles: 0
    }
  },
  props: ['tmzId'],
  methods: {
    getTmzReport() {
      if (this.tmzId){
        this.$store.dispatch("getTmzReport", this.tmzId).then((response) => {
          this.step = response.step;
        });
      }
    },
    firstStepTrigger() {
      this.$store.dispatch('updateCurrentStep', 1)
    },
    secondStepTrigger() {
      this.$store.dispatch('updateCurrentStep', 2)
    },
    thirdStepTrigger() {
      this.$store.dispatch('updateCurrentStep', 3)
    },
    nextStep() {
      
      // if (this.currentStep == 1) {
      //   this.currentStep++;
      //   this.$store.dispatch('updateCreateCurrentStep', this.currentStep)
      //   this.$router.push({ name: 'create-tmz-step-second' })
      // } else if (this.currentStep == 2) {
      //   this.currentStep++;
      //   this.$store.dispatch('updateCreateCurrentStep', this.currentStep)
      //   this.$router.push({ name: 'create-tmz-step-third' })
      // } else {

      // }

      const circles = this.circleSelector;

      if (this.currentStep > circles.length) {
        this.currentStep = circles.length
      }

      

      this.updateSteps()
    },
    prevStep() {
      // if (this.currentStep == 3) {
      //   this.currentStep--;
      //   this.$store.dispatch('updateCreateCurrentStep', this.currentStep)
      //   this.$router.push({ name: 'create-tmz-step-second' })
      // } else if (this.currentStep == 2) {
      //   this.currentStep--;
      //   this.$store.dispatch('updateCreateCurrentStep', this.currentStep)
      //   this.$router.push({ name: 'create-tmz-step-first' })
      // } else {
        
      // }

      const circles = this.circleSelector;

      if (this.currentStep < 1) {
        this.currentStep = 1
      }

      this.updateSteps()
    },
    updateSteps() {
      const circles = this.circleSelector;
      let progress = this.progressBar;


      circles.forEach((circle, index) => {
          if (index < this.currentStep) {
            circle.classList.add('active')
          } else {
            circle.classList.remove('active')
          }
        })

        
        // if (this.currentStep == 1) {
        //   progress.style.width = 0 + "%";
        // } else if (this.currentStep == 2) {
        //   progress.style.width = 50 + "%";
        // } else {
        //   progress.style.width = 100 + "%";
        // }

        // if (this.currentStep == 1) {
        //   prev.disabled = true
        // } else if (this.currentStep == circles.length) {
        //   next.disabled = true
        // } else {
        //   prev.disabled = false
        //   next.disabled = false
        // }

    }
  },
  computed: {
    circleSelector() {
      return document.querySelectorAll('.circle')
    },
    progressBar() {
      return document.querySelector('#progress')
    }
  },
  created() {
    this.getTmzReport();
    this.updateSteps()
  },
  async mounted() {

    // const progress = document.querySelector("#progress");
    this.currentStep = this.$store.getters.getCreateCurrentState;
    

    this.updateSteps()


    // const progress = document.querySelector("#progress"), 
    //   prev = document.querySelector("#prev"),
    //   next = document.querySelector("#next"),
    //   circles = document.querySelectorAll(".circle");


      // let currentActive = this.currentStep;

      // next.addEventListener("click", () => {
      //     this.currentStep++;
      //     if (this.currentStep > circles.length) {
      //       this.currentStep = circles.length;
      //     }
      //     update()
      // });

      // prev.addEventListener("click", () => {
      //     this.currentStep--;
      //     if (this.currentStep < 1) {
      //       this.currentStep = 1;
      //     }
      //     update();
      // });

      // function update() {
      //   circles.forEach((circle, index) => {
      //     if (index < currentActive) {
      //       circle.classList.add('active')
      //     } else {
      //       circle.classList.remove('active')
      //     }
      //   })
      //   const actives = document.querySelectorAll('.active');
      //   progress.style.width = ((actives.length - 1) / (circles.length - 1)) * 100 + "%";

      //   if (currentActive == 1) {
      //     prev.disabled = true
      //   } else if (currentActive == circles.length) {
      //     next.disabled = true
      //   } else {
      //     prev.disabled = false
      //     next.disabled = false
      //   }
      // }

      

  }
}
</script>

<style scoped>
.step-header {
  display: flex;
  justify-content: center;
  align-items: center;
}

a {
  color: black;
  text-decoration: none;
  margin: 20px;
}

.container {
  text-align: center;
}

.progress-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 350px;
  margin: 0 auto;
  max-width: 100%;
}

.progress-container::before {
  content: "";
  background: #bdbdbd;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 4px;
  width: 100%;
  z-index: -1;
  transition: 0.4s ease;
}

.progress {
  background: #36429E;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 4px;
  width: 0%;
  z-index: -1;
  transition: 0.4s ease;
}


.circle {
  background-color: #fff;
  color: #999;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  border: 3px solid #b2bec3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s ease;
  cursor: pointer;
}

.circle.active {
  border-color: #36429E;
}

.step-btn {
  background-color: #36429E;
  color: #fff;
  border-radius: 6px;
  border: 0;
  cursor: pointer;
  padding: 8px 30px;
  margin: 5px;
  font-size: 14px;
}

.step-btn:focus {
  outline: 0;
}

.step-btn:active {
  transform: scale(0.97);
}

.step-btn:disabled {
  background-color: #bdbdbd;
  cursor: not-allowed;
}

</style>